<template>
  <div class="home">
                <section>
                    <div class="py-8 px-8">
                    <div class="d-flex flex-wrap align-items-center justify-content-between">
                        <div class="col-12 col-lg-auto mb-3 mb-lg-0">
                            <div class="d-flex align-items-center">
                                <h4 class="mb-0 me-2">{{$t('attachments')}}</h4>
                            </div>
                        </div>
                        <div class="col-12 col-lg-auto d-flex align-items-center gap-2">
                            <div class="input-group flex-grow-1" style="border-bottom: 1px solid #ddd;">
                                <input class="form-control border-0 search-input" autocomplete="off" type="text" v-model="search" :placeholder="$t('search')">
                            </div>
                            <button @click="showFilters = !showFilters" class="btn btn-outline-secondary d-md-none">
                                <AppIcon name="bi-funnel" class="bi bi-funnel" />
                            </button>
                        </div>
                    </div>
                    </div>
                </section>
      
            <section class="">
                <div class="px-8">
                    

                    <!-- Storage Progress Bar -->
                    <div class="row mb-3">
                        <div class="col-8">
                            <div class="progress" style="height: 37px;">
                                <div class="progress-bar p-2" role="progressbar" :style="{ width: (size / (500 * 1024 * 1024) * 100) + '%' }" aria-valuenow="size" aria-valuemin="0" aria-valuemax="100">
                                    {{ (size / (500 * 1024 * 1024) * 100).toFixed(2) }}%
                                </div>
                            </div>
                            <small class="text-muted">{{$t('max_storage_limit')}}: 500MB (Request for more storage)</small>
                        </div>
                        <div class="col-4">
                            <!-- Filters section -->
                            <div class="row align-items-end g-2 mb-4" :class="{'d-none d-md-flex': !showFilters}">
                                <div class="col-6">
                                    <label class="form-label small d-md-none mb-1">{{$t('filter_by_date')}}</label>
                                    <select v-model="dateRangeOption" @change="handleDateRangeChange" class="form-select form-select-sm">
                                        <option value="">{{$t('filter_by_date')}}</option>
                                        <option value="today">{{$t('today')}}</option>
                                        <option value="yesterday">{{$t('yesterday')}}</option>
                                        <option value="this_week">{{$t('this_week')}}</option>
                                        <option value="last_week">{{$t('last_week')}}</option>
                                        <option value="this_month">{{$t('this_month')}}</option>
                                        <option value="custom">{{$t('custom_date')}}</option>
                                    </select>
                                </div>
                                <div class="col-6" v-if="dateRangeOption === 'custom'">
                                    <label class="form-label small d-md-none mb-1">{{$t('custom_date')}}</label>
                                    <date-picker :clearable="true" :editable="false" class="w-100" v-model="range" type="date" range :multi-calendars="1" :placeholder="$t('select_date_range')"></date-picker>
                                </div>
                                <div class="col-6 d-none d-md-block" v-if="helper.checkAccess('create_attachments') != -1">
                                    <div class="dropdown">
                                        <button class="btn btn-sm btn-success dropdown-toggle w-100" type="button" id="createDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                            {{$t('create')}}
                                        </button>
                                        <ul class="dropdown-menu w-100" aria-labelledby="createDropdown">
                                            <li>
                                                <a class="dropdown-item" href="#" @click.prevent="create" :class="{'disabled': size >= 500 * 1024 * 1024}">
                                                    <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                                                    {{$t('attachment')}}
                                                    <!-- <span v-if="business && business.status != 'active'" class="badge bg-secondary ms-2">{{$t('pro')}}</span> -->
                                                </a>
                                            </li>
                                            <li>
                                                <a class="dropdown-item" href="#" @click.prevent="createFolder">
                                                    <AppIcon name="bi-folder-plus" class="bi bi-folder-plus me-2" />
                                                    {{$t('new_folder')}}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Mobile action buttons -->
                    <div class="d-flex d-md-none gap-2 mb-3" v-if="helper.checkAccess('create_attachments') != -1">
                        <div class="dropdown flex-grow-1">
                            <button class="btn btn-sm btn-success dropdown-toggle w-100" type="button" id="createDropdownMobile" data-bs-toggle="dropdown" aria-expanded="false">
                                <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                                <AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />{{$t('create')}}
                            </button>
                            <ul class="dropdown-menu w-100" aria-labelledby="createDropdownMobile">
                                <li>
                                    <a class="dropdown-item" href="#" @click.prevent="create" :class="{'disabled': size >= 500 * 1024 * 1024}">
                                        <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                                        {{$t('attachment')}}
                                        <!-- <span v-if="business && business.status != 'active'" class="badge bg-secondary ms-2">{{$t('pro')}}</span> -->
                                    </a>
                                </li>
                                <li>
                                    <a class="dropdown-item" href="#" @click.prevent="createFolder">
                                        <AppIcon name="bi-folder-plus" class="bi bi-folder-plus me-2" />
                                        {{$t('new_folder')}}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    

                    <!-- Add breadcrumb navigation -->
                    <nav aria-label="breadcrumb" class="mb-4">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <a href="#" @click.prevent="navigateToFolder(null)" class="text-decoration-none">
                                  {{$t('root')}}
                                </a>
                            </li>
                            <li  v-if="currentFolder" class="breadcrumb-item">
                                <a href="#" @click.prevent="navigateToFolder(currentFolder)" class="text-decoration-none">
                                    {{currentFolder.name}}
                                </a>
                            </li>
                        </ol>
                    </nav>
                    
                <div class="px-4 pb-4 mb-6 bg-white rounded shadow mt-6">
                    <!-- Grid View -->
                    <div class="row g-4">
                        <!-- Folders -->
                        <div v-for="folder in folders" :key="'folder-'+folder.id" class="col-md-4 col-sm-6">
                            <div class="card h-100 folder-card">
                                <div class="card-body text-center position-relative">
                                    <!-- Privacy Badge - Top Right -->
                                    <div class="privacy-badge" v-if="helper.checkAccess('view_attachments') != -1">
                                        <span v-if="folder.is_private" class="badge bg-secondary">
                                            <AppIcon name="bi-lock-fill" class="bi bi-lock-fill" />
                                        </span>
                                        <span v-else class="badge bg-success">
                                            <AppIcon name="bi-unlock-fill" class="bi bi-unlock-fill" />
                                        </span>
                                    </div>
                                    
                                    <!-- Action Buttons - Top Right Overlay -->
                                    <div class="action-buttons">
                                        <button v-if="helper.checkAccess('edit_attachments') != -1" 
                                                @click.stop="editFolder(folder)" 
                                                class="btn btn-action btn-sm"
                                                :title="$t('edit')">
                                            <AppIcon name="bi-pencil" class="bi bi-pencil" />
                                        </button>
                                        <button v-if="helper.checkAccess('edit_attachments') != -1" 
                                                @click.stop="showPermissionModal(folder)" 
                                                class="btn btn-action btn-sm"
                                                :title="$t('permissions')">
                                            <AppIcon name="bi-shield-lock" class="bi bi-shield-lock" />
                                        </button>
                                        <button v-if="helper.checkAccess('delete_attachments') != -1" 
                                                @click.stop="deleteFolder(folder)" 
                                                class="btn btn-action btn-danger btn-sm"
                                                :title="$t('delete')">
                                            <AppIcon name="bi-trash" class="bi bi-trash" />
                                        </button>
                                    </div>
                                    
                                    <!-- Clickable folder area -->
                                    <a href="#" @click.prevent="navigateToFolder(folder)" class="folder-link">
                                        <AppIcon name="bi-folder-fill" class="bi bi-folder-fill text-warning" style="font-size: 64px;" />
                                        <h5 class="card-title mt-3 mb-0">
                                            {{folder.name}}
                                        </h5>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <!-- Files -->
                        <div v-for="attachment in currentFiles" :key="'file-'+attachment.id" class="col-md-4 col-sm-6">
                            <div class="card h-100 file-card">
                                <div class="card-body position-relative p-0">
                                    <!-- Privacy & Type Badges - Top Left -->
                                    <div class="file-badges">
                                        <span class="badge badge-type">{{attachment.filetype}}</span>
                                        <span v-if="attachment.is_private" class="badge bg-secondary">
                                            <AppIcon name="bi-lock-fill" class="bi bi-lock-fill" />
                                        </span>
                                        <span v-else class="badge bg-success">
                                            <AppIcon name="bi-unlock-fill" class="bi bi-unlock-fill" />
                                        </span>
                                    </div>
                                    
                                    <!-- Action Buttons - Overlay on hover -->
                                    <div class="action-buttons">
                                        <button @click="preview(attachment)" 
                                                class="btn btn-action btn-sm"
                                                :title="$t('preview')">
                                            <AppIcon name="bi-eye" class="bi bi-eye" />
                                        </button>
                                        <button v-if="helper.checkAccess('edit_attachments') != -1" 
                                                @click="editRow(attachment)" 
                                                class="btn btn-action btn-sm"
                                                :title="$t('edit')">
                                            <AppIcon name="bi-pencil" class="bi bi-pencil" />
                                        </button>
                                        <button v-if="helper.checkAccess('edit_attachments') != -1" 
                                                @click="showMoveToFolderModal(attachment)" 
                                                class="btn btn-action btn-sm"
                                                :title="$t('move')">
                                            <AppIcon name="bi-folder" class="bi bi-folder" />
                                        </button>
                                        <button v-if="helper.checkAccess('edit_attachments') != -1"
                                                @click="showPermissionModal(attachment)"
                                                class="btn btn-action btn-sm"
                                                :title="$t('permissions')">
                                            <AppIcon name="bi-shield-lock" class="bi bi-shield-lock" />
                                        </button>
                                        <button v-if="helper.checkAccess('delete_attachments') != -1" 
                                                @click="deleteRow(attachment)" 
                                                class="btn btn-action btn-danger btn-sm"
                                                :title="$t('delete')">
                                            <AppIcon name="bi-trash" class="bi bi-trash" />
                                        </button>
                                    </div>
                                    
                                    <!-- Preview -->
                                    <div class="file-preview">
                                        <img v-if="attachment.filetype && attachment.filetype.includes('image')" 
                                             :src="attachment.filepath" 
                                             style="width: 100%; height: 200px; object-fit: contain;" />
                                        <object v-else 
                                                :data="attachment.filepath + (attachment.filetype && attachment.filetype.includes('pdf') && !attachment.filepath.includes('#') ? '#view=Fit' : '')" 
                                                :type="attachment.filetype || 'application/pdf'" 
                                                style="width:100%; height:200px; pointer-events: none; object-fit: contain;">
                                            <div class="preview-fallback">
                                                <AppIcon name="bi-file-earmark-text" class="bi bi-file-earmark-text" style="font-size: 48px; color: #6c757d;" />
                                            </div>
                                        </object>
                                    </div>
                                    
                                    <!-- File Info -->
                                    <div class="file-info-section p-3">
                                        <h5 class="card-title mb-0 text-truncate" :title="attachment.filename">
                                            {{attachment.filename}}
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <table-loading-bar v-if="loading" class="text-center" />
                    <div v-if="loading === false && !attachments.length && !currentFolders.length" 
                         class="text-center py-5 my-5 bg-white rounded shadow-sm border" style="border-style: dashed !important;">
                        <AppIcon name="bi-paperclip" class="bi bi-paperclip text-muted" style="font-size: 3rem;" />
                        <h4 class="mt-3">{{ $t('no_attachments_added') }}</h4>
                        <p class="text-muted">{{ $t('start_by_adding_attachments') }}</p>
                        <template v-if="helper.checkAccess('create_attachments') != -1">
                            <button class="btn btn-outline-primary mt-2" @click="create" :disabled="size >= 500 * 1024 * 1024">
                                {{ $t('add_first_attachment') }}
                            </button>
                        </template>
                    </div>

                    <div v-if="loading === false && count > attachments.length" 
                         class="text-center mt-4">
                        <compact-pagination :pages="pagination" :current-page="page" @change="getAttchements" />
                    </div>
                </div>

                <div class="col-sm-9">
                    {{$t('show')}}
                    <select v-model="per_page" class="form-select mb-3" name="Resulats" style="cursor:pointer;margin-right: 5px;width:100px;display:inline-block">
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    {{$t('entities')}}
                </div>
                </div>
            </section>

        <!-- create Modal -->
        <div class="modal fade" id="create-modal" tabindex="-1" aria-labelledby="create-modal" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{$t('create_attachment')}}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                </div>
                <div class="modal-body" style="text-align:left">

                    <div class="mb-3">
                        <label class="form-label">{{$t('file')}}</label>
                        <div 
                            class="drop-zone" 
                            @dragover.prevent="onDragOver"
                            @dragleave.prevent="onDragLeave"
                            @drop.prevent="onDrop"
                            @click="$refs.fileInput.click()"
                            :class="{ 'dragging': isDragging }"
                        >
                            <div class="drop-zone-content">
                                <AppIcon name="bi-cloud-upload" class="bi bi-cloud-upload" style="font-size: 48px;" />
                                <p class="mt-2 mb-0">{{$t('drag_drop_file')}}</p>
                                <p class="text-muted small">{{$t('or_click_to_select')}}</p>
                                <input 
                                    type="file" 
                                    ref="fileInput" 
                                    @change="onFileSelected" 
                                    class="file-input" 
                                    accept=".jpg, .jpeg, .png, .doc, .docx, .pdf"
                                >
                            </div>
                        </div>
                        <div v-if="file" class="selected-file mt-2">
                            <div class="d-flex align-items-center">
                                <AppIcon name="bi-file-earmark" class="bi bi-file-earmark me-2" />
                                <span class="text-truncate">{{ file.name }}</span>
                                <button @click="removeFile" class="btn btn-sm btn-link text-danger ms-auto">
                                    <AppIcon name="bi-x" class="bi bi-x" />
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label for="exampleFormControlInput1" class="form-label">{{$t('name')}}</label>
                        <input v-model="attachment.filename" type="string" class="form-control" id="exampleFormControlInput1" placeholder="File name">
                    </div>

                    <!--
                    <div class="mb-3">
                        <input type="text"  class="form-control"  :placeholder="$t('hit_enter_to_add_tag')" v-model="newTag" @keyup.enter="addTag">
                        <div v-for="(tag, index) in attachment.tags" :key="index" class="badge bg-success rounded-pill small">{{ tag }} <span style="cursor:pointer" @click="removeTag(index)">x</span></div>
                    </div>
                    -->
                    <div class="mb-3">
                        <collapsible-notes-field v-model="attachment.notes" id="attachment-create-notes" rows="1" />
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                    <button type="button" class="btn btn-success" :disabled="loading || business && business.status != 'active'" @click="save"><AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />{{$t('create')}}</button>
                </div>
                </div>
            </div>
        </div>
        <!-- create modal -->

        <!-- Create Folder Modal -->
        <div class="modal fade" id="create-folder-modal" tabindex="-1" aria-labelledby="create-folder-modal" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{$t('create_folder')}}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                    </div>
                    <div class="modal-body" style="text-align:left">
                        <div class="mb-3">
                            <label for="folderName" class="form-label">{{$t('folder_name')}}</label>
                            <input v-model="newFolder.name" type="text" class="form-control" id="folderName" :placeholder="$t('enter_folder_name')">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                        <button type="button" class="btn btn-primary" @click="saveFolder" :disabled="!newFolder.name"><AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />{{$t('create')}}</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Create Folder Modal -->

        <!-- Edit Modal -->
        <div class="modal fade" id="edit-modal" tabindex="-1" aria-labelledby="edit-modal" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{$t('edit_attachment')}}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
            </div>
             <div v-if="showEditAttachmentModalisOpen === true" class="modal-body" style="text-align:left">

                <div class="mb-3">
                    <img v-if="attachment.filetype && attachment.filetype.includes('image')" 
                         :src="attachment.filepath" 
                         style="width: 100%; height: 300px; object-fit: contain;" />
                    <object v-else 
                            :data="attachment.filepath + (attachment.filetype && attachment.filetype.includes('pdf') && !attachment.filepath.includes('#') ? '#view=Fit' : '')" 
                            :type="attachment.filetype || 'application/pdf'" 
                            width="100%" height="300px" style="object-fit: contain;">
                        <!-- Fallback content in case the browser doesn't support PDF rendering -->
                        <p>Sorry, your browser doesn't support embedded PDFs.</p>
                    </object>
                </div>      

                <div class="mb-3">
                    <label for="exampleFormControlInput1" class="form-label">{{$t('name')}}</label>
                    <input v-model="attachment.filename" type="string" class="form-control" id="exampleFormControlInput1" placeholder="Category x">
                </div>

                <!--
                <div class="mb-3">
                    <input type="text"  class="form-control"  :placeholder="$t('hit_enter_to_add_tag')" v-model="newTag" @keyup.enter="addTag">
                    <div v-for="(tag, index) in attachment.tags" :key="index" class="badge bg-success rounded-pill small">{{ tag }} <span style="cursor:pointer" @click="removeTag(index)">x</span></div>
                </div>
                -->

                <div class="mb-3">
                    <collapsible-notes-field v-model="attachment.notes" id="attachment-edit-notes" rows="1" />
                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                <button type="button" class="btn btn-success" :disabled="loading || business && business.status != 'active'" @click="update"> <AppIcon name="bi-pencil" class="bi bi-pencil" style="font-size:12px" />{{$t('edit')}}</button>
            </div>
            </div>
        </div>
        </div>
        <!-- Edit modal -->

        <div class="modal fade" id="show-preview" tabindex="-1" aria-labelledby="show-preview" aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{$t('preview')}}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                </div>
                <div v-if="showPreviewModalisOpen === true" class="modal-body" style="text-align:left">

                <div class="px-4 pb-4 mb-6 bg-white rounded shadow">
                    
                    <div v-if="attachment">
                        <img v-if="attachment.filetype && attachment.filetype.includes('image')" 
                             :src="attachment.filepath" 
                             style="width: 100%; height: 500px; object-fit: contain;" />
                        <object v-else 
                                :data="attachment.filepath + (attachment.filetype && attachment.filetype.includes('pdf') && !attachment.filepath.includes('#') ? '#view=Fit' : '')" 
                                :type="attachment.filetype || 'application/pdf'" 
                                width="100%" height="500px" style="object-fit: contain;">
                            <!-- Fallback content in case the browser doesn't support PDF rendering -->
                            <p>Sorry, your browser doesn't support embedded PDFs.</p>
                        </object>
                    </div>

                </div>
             
            </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                </div>
                </div>
            </div>
        </div>

        <!-- Edit Folder Modal -->
        <div class="modal fade" id="edit-folder-modal" tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{$t('edit_folder')}}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
                            <label class="form-label">{{$t('folder_name')}}</label>
                            <input v-model="editingFolder.name" type="text" class="form-control" :placeholder="$t('enter_folder_name')">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                        <button type="button" class="btn btn-primary" @click="updateFolder" :disabled="!editingFolder.name"><AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />{{$t('save')}}</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Move to Folder Modal -->
        <div class="modal fade" id="move-to-folder-modal" tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{$t('move_to_folder')}}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
                            <label class="form-label">{{$t('select_folder')}}</label>
                            <select v-model="selectedFolderId" class="form-select">
                                <option value="null">{{$t('root_folder')}}</option>
                                <option v-for="folder in allFolders" :key="folder.id" :value="folder.id">
                                    {{folder.name}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{$t('cancel')}}</button>
                        <button type="button" class="btn btn-primary" @click="moveToFolder" :disabled="!selectedFolderId">{{$t('move')}}</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Add Permission Modal -->
        <div class="modal fade" id="permission-modal" tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{$t('access_control')}}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" v-model="selectedItem.is_private" @change="togglePrivacy">
                                <label class="form-check-label">
                                    {{ selectedItem.is_private ? $t('private') : $t('public') }}
                                </label>
                            </div>
                        </div>
                        <div v-if="selectedItem.is_private" class="mb-3">
                            <label class="form-label">{{$t('allowed_users')}}</label>
                            <div class="mb-2">
                                <div v-for="userId in selectedUsers" :key="userId" class="badge bg-primary me-2 mb-2">
                                    {{ users.find(u => u.id === userId)?.name || users.find(u => u.id === userId)?.email }}
                                    <AppIcon name="bi-x-circle" class="bi bi-x-circle ms-1" style="cursor: pointer" @click="removeUserAccess(userId)" />
                                </div>
                            </div>
                            <select v-model="selectedUsers" class="form-select" multiple size="5">
                                <option v-for="user in users" :key="user.id" :value="user.id">
                                    {{user.name || user.email}}
                                </option>
                            </select>
                            <small v-if="!users.length" class="text-muted">{{$t('no_users_found')}}</small>
                            <small v-else class="text-muted">{{$t('select_users')}}</small>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                        <button type="button" class="btn btn-primary" @click="updatePermissions"><AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />{{$t('save')}}</button>
                    </div>
                </div>
            </div>
        </div>

  </div>
</template>

<script>
// @ is an alias to /src
import helper from '../../helper'
import moment from 'moment'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

const maxAllowedSize = 20 * 1024 * 1024; //20MB

export default {
  name: 'Attachment',
  persistedFilterState: {
    key: 'attachments',
    fields: ['search', 'dateRangeOption', 'range', 'start', 'end', 'per_page', 'currentFolderId'],
    dateFields: ['range'],
  },
  components :{
    DatePicker,
  },
  data(){
    return {
        search : '',
        attachments : [],
        count : 0,
        page : 1,
        newTag: '',
        attachment : {
            filename : '',
            tags : []
        },
        range: [],
        start : null,
        end : null,
        dateRangeOption: '',
        showFilters: false,
        createModal : null,
        editModal : null,
        loading : false,
        per_page : 25,
        pagination : [],
        showPreviewModalisOpen : false,
        showProductModal : null,
        showEditAttachmentModalisOpen :false,
        url : '',
        file : null,
        showPreviewModal : null,
        size : 0,
        folders: [],
        currentFolderId: null,
        currentFolder : null,
        folderPath: [],
        newFolder: {
            name: '',
            parent_id: null
        },
        editingFolder: {
            id: null,
            name: '',
            parent_id: null
        },
        createFolderModal: null,
        editFolderModal: null,
        moveToFolderModal: null,
        selectedFolderId: null,
        fileToMove: null,
        allFolders: [],
        isDragging: false,
        permissionModal: null,
        selectedItem: {
            id: null,
            is_private: true,
            allowed_users: ''
        },
        selectedUsers: [],
        users: [],
    }
  },
  mounted(){
    window.mixpanel.track("attachment");

    //check permissions
    if(helper.checkAccess('view_attachments') == -1) return this.$router.push({path : '/'})
    if(helper.checkAccess('view_attachments') == -2) return this.$router.push({path : '/subscribe'})
    
    // Initialize this_month date range
    this.handleDateRangeChange()
    
    this.getSize()
    this.getattachments()

    // eslint-disable-next-line no-undef
    this.createModal = new bootstrap.Modal(document.getElementById('create-modal'))

    // eslint-disable-next-line no-undef
    this.showPreviewModal = new bootstrap.Modal(document.getElementById('show-preview'))
    document.getElementById('show-preview').addEventListener('hidden.bs.modal', () => { this.showPreviewModalisOpen = false })

    // eslint-disable-next-line no-undef
    this.editModal = new bootstrap.Modal(document.getElementById('edit-modal'))
    document.getElementById('edit-modal').addEventListener('hidden.bs.modal', () => { this.showEditAttachmentModalisOpen = false })

    // eslint-disable-next-line no-undef
    this.createFolderModal = new bootstrap.Modal(document.getElementById('create-folder-modal'));
    
    // eslint-disable-next-line no-undef
    this.editFolderModal = new bootstrap.Modal(document.getElementById('edit-folder-modal'));
    this.getFolders();

    // eslint-disable-next-line no-undef
    this.moveToFolderModal = new bootstrap.Modal(document.getElementById('move-to-folder-modal'));

    // eslint-disable-next-line no-undef
    this.permissionModal = new bootstrap.Modal(document.getElementById('permission-modal'));
    this.getUsers();

  },
  methods : {
    create(){
        this.clearForm()
        this.createModal.show()
    },
    editRow(row){
        this.attachment = row 
        this.showEditAttachmentModalisOpen = true
        this.editModal.show()
    },
    async save(){
        try{
            this.loading = true
            if(!this.file) return alert('FILE IS MISSING')
            const url = await this.onUpload(this.file)
            this.attachment.filepath = url
            this.attachment.filetype = this.file.type
            this.attachment.filesize = this.file.size
            // await helper.customPost(`${process.env.VUE_APP_API}/attachments`,{...this.attachment, tags : this.attachment.tags.toString() } ,{showToast:true})
            this.loading = false
            this.getattachments()
            this.clearForm()
            this.createModal.hide()
        }catch(error){
            this.loading = false
        }
    },
    onUpload(file){
        // if(this.business && this.business.status != 'active') return;
        return helper.customUploadFile(file,`businesses/${this.business.id}/attachments/${helper.generateRandString(20)}`,{...this.attachment,folder_id: this.currentFolderId})
    },
    async update(){
        try{
            this.loading = true
            await helper.customPatch(`${process.env.VUE_APP_API}/attachments/${this.attachment.id}`,{
                ...this.attachment
            })
            this.loading = false
            this.clearForm()
            this.editModal.hide()
            this.getattachments()
        }catch(error){
            this.loading = false
        }

    },
    async deleteRow(row){
        this.$swal.fire({
        title: this.$t('are_you_sure'),
        text : this.$t('you_cant_revert'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes_delete_it')
        }).then(async (result) => {
            if (result.isConfirmed) {
                await helper.customDelete(`${process.env.VUE_APP_API}/attachments/${row.id}`)
                this.attachments = helper.withoutDeletedRecords(this.attachments, row.id)
                this.count = Math.max(0, this.count - 1)
            }
        })
    },
    preview(attachment){
      window.open(attachment.filepath, '_blank');
    },
    download(attachment){
        // Create a temporary anchor element
        const link = document.createElement('a');
        link.href = attachment.filepath;
        link.setAttribute('download', attachment.filename);

        // Append the anchor element to the body
        document.body.appendChild(link);

        // Trigger the download
        link.click();

        // Cleanup
        document.body.removeChild(link);
    },
    clearForm(){
        this.attachment = {
            filename : '',
            tags : []
        }
        this.file = null
        this.isDragging = false
        if (this.$refs.fileInput) {
            this.$refs.fileInput.value = '';
        }
    },
    async getattachments(page){
            this.loading = true
            this.page = page ? this.page : 1
            let url = this.start ? 
                `${process.env.VUE_APP_API}/attachments?page=${this.page}&start=${this.start}&end=${this.end}&per_page=${this.per_page}` : 
                `${process.env.VUE_APP_API}/attachments?page=${this.page}&per_page=${this.per_page}`
            
            this.attachments = []
            this.folders = []
            if(this.search != ""){
                url = `${process.env.VUE_APP_API}/attachments?keyword=${this.search}`
            }

            // Add folder_id to query if we're in a folder
            if (this.currentFolderId) {
                url += `&folder_id=${this.currentFolderId}`
            }
            
            // Fetch both folders and files
            const [filesResponse, foldersResponse] = await Promise.all([
                helper.customGet(url),
                helper.customGet(`${process.env.VUE_APP_API}/folders?parent_id=${this.currentFolderId || 'null'}`)
            ]);

            this.loading = false

            // Process files
            let files = filesResponse.data.data;
            // for(let i = 0 ; i < files.length ; i++){
            //     if(files[i].tags){
            //         files[i].tags = files[i].tags.split(',')
            //     }
            // }

            // Process folders
            const folders = foldersResponse.data;
            this.folders = folders
            // Combine folders and files
            this.attachments = [...folders, ...files];
            this.count = filesResponse.data.count + folders.length;

            if(this.per_page != filesResponse.data.per_page){
                this.per_page = filesResponse.data.per_page
            }

            // Update folder path after loading new data
            this.updateFolderPath();

            //pagination
            this.pagination = []
            let MaxPagination = Math.ceil(this.count / this.per_page )
            for(let i = 1 ; i <= MaxPagination ;i++){
                this.pagination.push(i)
            }
        
    },
    async getSize(){
        try{
            this.loading = true
            let url = `${process.env.VUE_APP_API}/attachments-size`

            const response = await helper.customGet(url)
            this.size = response.data.size
            this.loading = false

        }catch(error){
            this.loading = false
        }

    },
    onDragOver() {
        this.isDragging = true;
    },
    onDragLeave() {
        this.isDragging = false;
    },
    onDrop(event) {
        this.isDragging = false;
        const files = event.dataTransfer.files;
        if (files.length > 0) {
            this.handleFile(files[0]);
        }
    },
    onFileSelected(event) {
        const files = event.target.files;
        if (files.length > 0) {
            this.handleFile(files[0]);
        }
    },
    handleFile(file) {
        if (file.size > maxAllowedSize) {
            this.$swal.fire({
                icon: 'error',
                title: this.$t('error'),
                text: this.$t('file_too_large')
            });
            return;
        }
        this.file = file;
        this.attachment.filename = file.name;
    },
    removeFile() {
        this.file = null;
        this.attachment.filename = '';
        if (this.$refs.fileInput) {
            this.$refs.fileInput.value = '';
        }
    },
    formatDate(date) { return helper.formatDate(date) },
    async getFolders() {
            const response = await helper.customGet(`${process.env.VUE_APP_API}/folders`);
            this.folders = response.data;
    },
    async navigateToFolder(folder) {
        this.currentFolder = folder
        this.currentFolderId = folder?.id ? folder.id : null;
        this.page = 1; // Reset to first page when changing folders
        
        try {
            this.loading = true;
            
            // If we're navigating to a specific folder, get its details first
            if (this.currentFolder) {
                await helper.customGet(`${process.env.VUE_APP_API}/folders/${this.currentFolderId}`);
                
                // Update folder path
                this.folderPath = [];
                let currentId = this.currentFolderId;
                while (currentId) {
                    const currentFolder = await helper.customGet(`${process.env.VUE_APP_API}/folders/${currentId}`);
                    this.folderPath.unshift(currentFolder.data);
                    currentId = currentFolder.data.parent_id;
                    
                }
            } else {
                // If we're going to root, clear the path
                this.folderPath = [];
            }
            
            // Get attachments for the current folder
            await this.getattachments();
            
        } catch (e) {
            this.$swal.fire({
                icon: 'error',
                title: this.$t('error'),
                text: e.message
            });
        } finally {
            this.loading = false;
        }
    },
    updateFolderPath() {
        this.folderPath = [];
        if (!this.currentFolderId) return;

        const findFolder = (id) => {
            return this.attachments.find(f => f.id === id && !f.filetype);
        };

        let currentId = this.currentFolderId;
        while (currentId) {
            const folder = findFolder(currentId);
            if (folder) {
                this.folderPath.unshift(folder);
                currentId = folder.parent_id;
            } else {
                break;
            }
        }
    },
    createFolder() {
      this.newFolder = {
        name: '',
        parent_id: this.currentFolderId
      };
      this.createFolderModal.show();
    },
    async saveFolder() {
      try {
        await helper.customPost(`${process.env.VUE_APP_API}/folders`, this.newFolder);
        this.createFolderModal.hide();
        this.getFolders();
        this.getattachments();
      } catch (e) {
         this.$swal.fire({
                icon: 'error',
                title: this.$t('error'),
                text: e.message
            });
      }
    },
    editFolder(folder) {
      this.editingFolder = { ...folder };
      this.editFolderModal.show();
    },
    async updateFolder() {
      try {
        await helper.customPatch(`${process.env.VUE_APP_API}/folders/${this.editingFolder.id}`, {
          name: this.editingFolder.name
        });
        this.editFolderModal.hide();
        this.getFolders();

      } catch (e) {
         this.$swal.fire({
                icon: 'error',
                title: this.$t('error'),
                text: e.message
            });
      }
    },
    async deleteFolder(folder) {
      this.$swal.fire({
        title: this.$t('are_you_sure'),
        text: this.$t('you_cant_revert'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes_delete_it')
      }).then(async(result) => {
        if (result.isConfirmed) {
          await helper.customDelete(`${process.env.VUE_APP_API}/folders/${folder.id}`);
          this.folders = helper.withoutDeletedRecords(this.folders, folder.id);
          this.allFolders = helper.withoutDeletedRecords(this.allFolders, folder.id);
        }
      }) 
    },
    async getAllFolders() {
            const response = await helper.customGet(`${process.env.VUE_APP_API}/folders`);
            // Filter out the current folder from the list
            this.allFolders = response.data.filter(folder => folder.id !== this.currentFolderId);
    },
    showMoveToFolderModal(attachment) {
        this.fileToMove = attachment;
        this.selectedFolderId = attachment.folder_id || 'null';
        this.getAllFolders();
        this.moveToFolderModal.show();
    },
    async moveToFolder() {
        try {
            this.loading = true;
            await helper.customPatch(`${process.env.VUE_APP_API}/attachments/${this.fileToMove.id}`, {
                folder_id: this.selectedFolderId === 'null' ? null : this.selectedFolderId
            });
            this.moveToFolderModal.hide();
            this.getattachments();
        } catch (error) {
            this.$swal.fire({
                icon: 'error',
                title: this.$t('error'),
                text: this.$t('error_moving_file')
            });
        } finally {
            this.loading = false;
        }
    },
    async getUsers() {
        try {
            this.loading = true;
            const response = await helper.customGet(`${process.env.VUE_APP_API}/users`);
            this.users = response.data.data;
            this.users = this.users.filter(user => user.id !== this.user.id)
        } catch (e) {
            this.$swal.fire({
                icon: 'error',
                title: this.$t('error'),
                text: e.message
            });
        } finally {
            this.loading = false;
        }
    },
    showPermissionModal(item) {
        this.selectedItem = { ...item };
        this.selectedUsers = item.allowed_users ? item.allowed_users.split(',').map(Number) : [];
        // Refresh users list when opening modal
        this.getUsers();
        this.permissionModal.show();
    },
    togglePrivacy() {
        if (!this.selectedItem.is_private) {
            this.selectedUsers = [];
        }
    },
    async updatePermissions() {
        try {
            const data = {
                is_private: this.selectedItem.is_private,
                allowed_users: this.selectedUsers.join(',')
            };

            // Determine if we're updating a folder or an attachment
            const isFolder = !this.selectedItem.filetype;
            const endpoint = isFolder ? 'folders' : 'attachments';

            await helper.customPatch(`${process.env.VUE_APP_API}/${endpoint}/${this.selectedItem.id}`, data);
            this.permissionModal.hide();
            this.getattachments();
        } catch (error) {
            this.$swal.fire({
                icon: 'error',
                title: this.$t('error'),
                text: this.$t('error_updating_permission')
            });
        }
    },
    removeUserAccess(userId) {
        this.selectedUsers = this.selectedUsers.filter(id => id !== userId);
    },
    // Handle date range selection
    handleDateRangeChange() {
      if (this.dateRangeOption === '') {
        this.range = []
        this.start = null
        this.end = null
        this.getattachments()
      } else if (this.dateRangeOption === 'today') {
        const start = new Date()
        const end = new Date()
        this.range = [start, end]
      } else if (this.dateRangeOption === 'yesterday') {
        const start = new Date()
        const end = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24)
        end.setTime(end.getTime() - 3600 * 1000 * 24)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'this_week') {
        const start = new Date()
        const end = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'last_week') {
        const start = new Date()
        const end = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 14)
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'this_month') {
        const start = new Date()
        const end = new Date()
        start.setDate(1)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'custom') {
        this.range = []
      }
    }
  },
  watch : {
    async search(){
        if(this.search.length > 2){
            try{
                this.loading = true
                const response = await helper.customGet(`${process.env.VUE_APP_API}/attachments?keyword=${this.search}`)
                this.attachments = response.data.data
                this.count = response.data.count
                this.loading = false
            }catch(error){
                this.loading = false
            }
        }
        if(this.search == '') return this.getattachments()
    },
    range(){
        

        if(this.range[0] == null){
            this.start = null
            this.end = null
            this.getattachments()
        }

        if(this.range.length && this.range[0] && this.range[1]){
            this.start = moment(this.range[0]).format('YYYY-MM-DD')
            this.end = moment(this.range[1]).format('YYYY-MM-DD')
            this.getattachments()
        }else{
            this.attachments = []
        }
    },
    per_page(){
        this.getattachments(this.page)
    }
  },
  computed : {
    currentFolders() {
        return this.attachments.filter(item => !item.filetype); // Folders don't have filetype
    },
    currentFiles() {
        return this.attachments.filter(item => item.filetype); // Files have filetype
    },
    user() { return this.$store.getters.USER },
    business() { return this.$store.getters.BUSINESS },
    helper() { return helper },
  }
}
</script>

<style scoped>
    /* Card Styles */
    .folder-card, .file-card {
        transition: all 0.3s ease;
        border: 1px solid rgba(0,0,0,0.08);
        background: #ffffff;
        border-radius: 12px;
        overflow: hidden;
        cursor: pointer;
    }

    .folder-card:hover, .file-card:hover {
        transform: translateY(-4px);
        box-shadow: 0 12px 24px rgba(0,0,0,0.12);
        border-color: rgba(13, 110, 253, 0.3);
    }

    /* Privacy Badge Positioning */
    .privacy-badge {
        position: absolute;
        top: 12px;
        right: 12px;
        z-index: 10;
    }

    .privacy-badge .badge {
        font-size: 0.7rem;
        padding: 0.35em 0.65em;
        border-radius: 6px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    }

    /* File Badges - Top Left */
    .file-badges {
        position: absolute;
        top: 12px;
        left: 12px;
        z-index: 10;
        display: flex;
        gap: 6px;
        flex-wrap: wrap;
    }

    .file-badges .badge {
        font-size: 0.7rem;
        padding: 0.35em 0.65em;
        border-radius: 6px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.15);
        backdrop-filter: blur(4px);
    }

    .badge-type {
        background-color: rgba(13, 110, 253, 0.9) !important;
        color: white !important;
    }

    .badge.bg-secondary {
        background-color: rgba(108, 117, 125, 0.9) !important;
        color: white !important;
    }

    .badge.bg-success {
        background-color: rgba(25, 135, 84, 0.9) !important;
        color: white !important;
    }

    /* Action Buttons - Overlay */
    .action-buttons {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 20;
        display: flex;
        gap: 8px;
        opacity: 0;
        transition: opacity 0.3s ease;
        pointer-events: none;
    }

    .folder-card:hover .action-buttons,
    .file-card:hover .action-buttons {
        opacity: 1;
        pointer-events: all;
    }

/* Make folder clickable */
.folder-card .folder-link {
    display: block;
    position: relative;
    z-index: 15;
    text-decoration: none;
    color: inherit;
    cursor: pointer;
    padding: 10px;
    margin: -10px;
    border-radius: 8px;
    transition: background-color 0.2s;
}

.folder-card .folder-link:hover {
    background-color: rgba(0, 0, 0, 0.03);
}

.folder-card .folder-link .card-title {
    color: #212529;
}    .btn-action {
        background: rgba(255, 255, 255, 0.95);
        border: 1px solid rgba(0, 0, 0, 0.1);
        color: #495057;
        padding: 0.5rem;
        width: 36px;
        height: 36px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s ease;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    }

    .btn-action:hover {
        background: white;
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(0,0,0,0.2);
        color: #0d6efd;
        border-color: #0d6efd;
    }

    .btn-action.btn-danger {
        color: #dc3545;
    }

    .btn-action.btn-danger:hover {
        background: #dc3545;
        color: white;
        border-color: #dc3545;
    }

    .btn-action i {
        font-size: 1rem;
    }

    /* File Preview */
    .file-preview {
        width: 100%;
        height: 200px;
        background: #f8f9fa;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid rgba(0,0,0,0.05);
    }

    .preview-fallback {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        background: linear-gradient(135deg, #f5f7fa 0%, #e9ecef 100%);
    }

    /* File Info Section */
    .file-info-section {
        background: white;
    }

    .card-title {
        font-size: 0.95rem;
        font-weight: 600;
        color: #2c3e50;
        line-height: 1.4;
    }

    .folder-name {
        transition: color 0.2s ease;
    }

    .folder-name:hover {
        color: #0d6efd !important;
    }

    /* Folder Icon */
    .folder-card .bi-folder-fill {
        transition: transform 0.3s ease;
    }

    .folder-card:hover .bi-folder-fill {
        transform: scale(1.1);
    }

    /* Remove old button group styles */
    .btn-group {
        display: none;
    }

    /* Rest of existing styles */
    .text-muted {
        color: #6c757d !important;
        font-size: 0.8rem;
    }

    .breadcrumb {
        background: transparent;
        padding: 0.75rem 0;
        margin-bottom: 1rem;
    }

    .breadcrumb-item {
        color: #6c757d;
        font-size: 0.9rem;
    }

    .breadcrumb-item:hover {
        color: #0d6efd;
    }

    .breadcrumb-item a {
        text-decoration: none;
        transition: color 0.2s ease;
    }

    .progress {
        height: 8px;
        border-radius: 4px;
        background-color: #e9ecef;
        margin-bottom: 0.5rem;
    }

    .progress-bar {
        background-color: #0d6efd;
        border-radius: 4px;
    }

    .search-input {
        border-radius: 8px;
        padding: 0.5rem 1rem;
        font-size: 0.9rem;
    }

    .search-input:focus {
        box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.15);
    }

    .drop-zone {
        border: 2px dashed #dee2e6;
        border-radius: 8px;
        padding: 2rem;
        text-align: center;
        cursor: pointer;
        transition: all 0.3s ease;
        background-color: #f8f9fa;
    }

    .drop-zone:hover {
        border-color: #0d6efd;
        background-color: #f1f8ff;
    }

    .drop-zone.dragging {
        border-color: #0d6efd;
        background-color: #e7f1ff;
    }

    .drop-zone-content {
        color: #6c757d;
    }

    .file-input {
        display: none;
    }

    .selected-file {
        background-color: #f8f9fa;
        padding: 0.5rem 1rem;
        border-radius: 6px;
        border: 1px solid #dee2e6;
    }

    .selected-file .btn-link {
        padding: 0;
        font-size: 1.2rem;
    }

    .selected-file .btn-link:hover {
        color: #dc3545 !important;
    }

    /* Dropdown styles */
    .dropdown-menu {
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        border: 1px solid rgba(0,0,0,0.1);
        padding: 0.5rem;
    }

    .dropdown-item {
        padding: 0.75rem 1rem;
        border-radius: 6px;
        transition: all 0.2s ease;
    }

    .dropdown-item:hover {
        background-color: #f8f9fa;
    }

    .dropdown-item.disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    .dropdown-item i {
        font-size: 1rem;
        width: 20px;
        text-align: center;
    }

    .dropdown-toggle::after {
        margin-left: 0.5rem;
    }

    /* Mobile Responsive */
    @media (max-width: 768px) {
        .action-buttons {
            opacity: 1;
            pointer-events: all;
            position: static;
            transform: none;
            justify-content: center;
            margin-top: 1rem;
        }

        .file-info-section {
            padding-bottom: 1rem !important;
        }
    }
</style>
